module.exports = __webpack_public_path__ + "static/Header Banner-4a0196e709ccff44e4fea3eb6cfd5811.png";